<template>
  <main class="container-selfservice-main">
    <PlansCardList :plan-benefits :plan-prices />

    <PlansCompare :plan-prices v-if="isDesktop" />
    <MobilePlansCompare :plan-prices v-else />

    <PlansPriceList :plan-prices />
  </main>
</template>

<script setup lang="ts">
import MobilePlansCompare from '@/components/domains/self-service/payment-settings/MobilePlansCompare.vue';
import PlansCardList from '@/components/domains/self-service/payment-settings/PlansCardList.vue';
import PlansCompare from '@/components/domains/self-service/payment-settings/PlansCompare.vue';
import PlansPriceList from '@/components/domains/self-service/payment-settings/PlansPriceList.vue';
import { useDeviceSize } from '@/composables/shared/useDeviceSize';
import { usePlan } from '@/composables/shared/usePlan';
import { usePaymentStore } from '@/stores/payment';
import { useSubscriptionStore } from '@/stores/subscription';

const paymentStore = usePaymentStore();
const subscriptionStore = useSubscriptionStore();

const { isDesktop } = useDeviceSize();
const { formatBenefitByCategory } = usePlan();

const planPrices = computed(() => subscriptionStore.planPrices);
const planBenefits = computed(() => {
  return {
    FREE: formatBenefitByCategory('FREE'),
    STARTER: formatBenefitByCategory('STARTER', planPrices.value['STARTER']),
    PRO: formatBenefitByCategory('PRO', planPrices.value['PRO']),
    ENTERPRISE: formatBenefitByCategory('ENTERPRISE'),
  };
});

onBeforeMount(async () => {
  await paymentStore.fetchUserCardList();
});
</script>
